import React, { useEffect, useState } from 'react';
import {
  TextField, Select, MenuItem, InputLabel, FormControl,
  FormGroup, Typography, Box, Divider
} from '@mui/material';
import './sponsorForm.css';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

const SponsorForm = ({ setShowSpinner }) => {
  const [status, setStatus] = useState('active');
  const [manager, setManager] = useState('Maheen');
  const [data, setData] = useState({})
  const navigate = useNavigate();
  let { id } = useParams();
  // Bearer Token
  const token = localStorage.getItem('token');
  const tokenValue = token ? token.slice(1, token.length - 1) : "";
  const user = localStorage.getItem('user');
  const _id = user && (typeof user === 'string' ? JSON.parse(user)._id : user._id);

  const getData = () => {
    setShowSpinner(true);
    axios.get(`https://research-mate-b35a10757d5a.herokuapp.com/api/sponsorStudy/single?id=${id}`, {
      headers: {
        "Content-Type": "appliccation/json"
      }
    })
      .then(res => {
        const response = res.data.data
        setData(response)
      })
      .catch(error => {
      })
    setShowSpinner(false);
  }

  const deleteStudy = (id) => {
    setShowSpinner(true);
    axios.delete(`https://research-mate-b35a10757d5a.herokuapp.com/api/sponsorStudy?id=${id}`, {
      headers: {
        "Content-Type": "appliccation/json"
      }
    })
      .then(res => {
        Swal.fire({
          icon: "success",
          title: "Added...",
          text: `study has been added to ${status} studies`,
          customClass: {
            container: 'swal2-container-custom'
          }
        })
          .then(() => {
            navigate('/sponsorStudy')
          })
      })
      .catch(error => {
      })
    setShowSpinner(false);
  }

  useEffect(() => {
    if (user) {
      getData()
    }
  }, [user])


  console.log(data.submissionDate);

  const handleSubmit = () => {
    setShowSpinner(true);
    const adminStudy = {
      phase: data.phase,
      title: data.title,
      indication: data.indication,
      therapeuticAreas: data.therapeuticAreas,
      sponsorName: data.sponsorName,
      CRO: data.CRO,
      inclusionCriteria: data.inclusionCriteria,
      exclusionCriteria: data.exclusionCriteria,
      activationDate: data.activationDate,
      submissionDate: data.submissionDate,
      status,
      manager,
      addedBy: _id,
    }
    const url = 'https://research-mate-b35a10757d5a.herokuapp.com/api/adminStudy/'
    axios.post(url, adminStudy, {
      headers: {
        'Authorization': `Bearer ${tokenValue}`
        // Add other headers if needed
      }
    })
      .then(res => {
        deleteStudy(id)
      })
      .catch(error => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.response?.data?.message,
          customClass: {
            container: 'swal2-container-custom'
          }
        });
      })
      .finally(() => {
        setShowSpinner(false);
      })
  }

  return (
    <Box sx={{ p: 3, color: '#169a8f', fontWeight: 'bold' }}>
      <div>
        <Typography sx={{ color: '#169a8f', fontWeight: '600', fontFamily: 'monospace' }} variant="h3" gutterBottom>Sponsor Study</Typography>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
          <button className="button" data-text="Awesome" onClick={handleSubmit} >
            <span className="actual-text">&nbsp;AcceptOrSave&nbsp;</span>
            <span aria-hidden="true" className="hover-text">&nbsp;AcceptOrSave&nbsp;</span>
          </button>
        </Box>
      </div>
      <Divider />

      <Box sx={{ mt: 3 }}>
        <Typography variant="h6">Study Criteria</Typography>
        <FormGroup row sx={{ mt: 2, display: 'flex', alignItems: 'center' }}>
          <FormControl sx={{ mr: 3 }}>
            <InputLabel id="phase-label">Phase</InputLabel>
            <Select labelId="phase-label" id="phase" value={data.phase || ""} label="Phase">
              <MenuItem value={"Phase I"}>Phase I</MenuItem>
              <MenuItem value={"Phase II"}>Phase II</MenuItem>
              <MenuItem value={"Phase III"}>Phase III</MenuItem>
              <MenuItem value={"Phase IV"}>Phase IV</MenuItem>
            </Select>
          </FormControl>
          <TextField
            id="activation-date"
            label="Activation Date"
            type="date"
            value={data.activationDate || ""}
            InputLabelProps={{ shrink: true }}
            sx={{ mr: 3 }}
          />
          <TextField
            id="submission-date"
            label="Submission Date"
            type="date"
            value={data.submissionDate || ""}
            InputLabelProps={{ shrink: true }}
          />
          <FormControl sx={{ mx: 3 }}>
            <InputLabel id="status-label">Status</InputLabel>
            <Select labelId="status-label" id="status" value={status} onChange={e => setStatus(e.target.value)} label="Status">
              <MenuItem value="active">Active</MenuItem>
              <MenuItem value="developing">Developing</MenuItem>
              <MenuItem value="closing">Closing</MenuItem>
            </Select>
          </FormControl>
          <FormControl sx={{ mx: 3 }}>
            <InputLabel id="manager-label">Manager</InputLabel>
            <Select labelId="manager-label" id="manager" value={manager} label="manger" onChange={e => setManager(e.target.value)}
              style={{ fontSize: 15, minWidth: '160px' }}
              MenuProps={{ // Style for menu options
                PaperProps: {
                  style: {
                    maxHeight: 300,
                    width: '20ch',
                  },
                },
              }}>
              <MenuItem value={"Maheen"}>Maheen</MenuItem>
              <MenuItem value={"Wardah"}>Wardah</MenuItem>
              <MenuItem value={"Evelyn"}>Evelyn</MenuItem>
              <MenuItem value={"Shariq"}>Shariq</MenuItem>
              <MenuItem value={"Ibrahim"}>Ibrahim</MenuItem>
              <MenuItem value={"Owais"}>Owais</MenuItem>

            </Select>
          </FormControl>
        </FormGroup>

        <TextField
          id="input-title"
          label="Title"
          fullWidth sx={{ mt: 2 }}
          value={data.title || ""}
        />
        <TextField
          value={data.therapeuticAreas || ""}
          label="Therapeutic Areas"
          fullWidth
          className='mt-3'
        />
        <TextField
          id="indication"
          label="Indication"
          fullWidth sx={{ mt: 2 }}
          value={data.indication || ""}
        />
      </Box>

      <Box sx={{ mt: 3 }}>
        <Typography variant="h6">Study Sponsors</Typography>
        <FormGroup row sx={{ mt: 2 }}>
          <TextField
            id="name-sponsors"
            label="Name Sponsors"
            sx={{ mr: 3 }}
            value={data.sponsorName || ""}
          />
          <TextField
            id="cro"
            label="CRO"
            sx={{ mr: 3 }}
            value={data.CRO || ""}
          />
          <TextField
            type="email"
            id="Email"
            label="Email"
            sx={{ width: '300px', mr: 3 }}
            value={data.email || ""}
          />
          <TextField
            type="number"
            id="Phone #"
            label="Phone #"
            sx={{ width: '300px' }}
            value={data.phone || ""}
          />
        </FormGroup>
      </Box>

      <Box sx={{ mt: 3 }}>
        <Divider />
        <Typography variant="h6" sx={{ mt: 2 }}>Criteria</Typography>
        <Box sx={{ mt: 2 }}>
          <TextField
            id="inclusion-criteria"
            label="Inclusion Criteria"
            multiline
            rows={6}
            fullWidth
            value={data.inclusionCriteria || ""}
          />
        </Box>
        <Box sx={{ mt: 2 }}>
          <TextField
            id="exclusion-criteria"
            label="Exclusion Criteria"
            multiline
            rows={6}
            fullWidth
            value={data.exclusionCriteria || ""}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default SponsorForm;